import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { Link } from "@reach/router";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  textfield: {
    marginRight: theme.spacing(2)
  }
}));

function FilterBar(props) {
  const classes = useStyles();
  const { value, handleChange, label, minWidth } = props;

  return (
    <TextField
      label={label ? label : "过滤"}
      value={value}
      onChange={handleChange}
      margin="normal"
      className={classes.textfield}
      style={{
        minWidth: minWidth
      }}
    />
  );
}

export default FilterBar;
